<template>
	<div class="card">
		<slot />
	</div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.card {
	width: 100%;
	background-color: var(--background-primary);
	border-radius: var(--radius-lg);
	box-shadow: var(--shadow-card);
	padding: 16px;
}
</style>
